const menuList = [
  {
    id: "1",
    title: "华师专利库",
    childrenList: [
      {
        name: "二级机构",
      },
      {
        name: "重点实验室",
      },
    ],
  },
  {
    id: "2",
    title: "专利专题库",
    childrenList: [
      {
        name: "渔业专题库",
      },
      {
        name: "云计算专题库",
      },
    ],
  },
  {
    id: "3",
    title: "华师知识产权资源平台",
  },
  {
    id: "4",
    title: "本校专利图谱",
  },
];

module.exports = {
  menuList,
};
